// Feature `internal_keycode` values grouped by which team/audience owns them.
// Used to bucket feature flags into Product / Software Team / Vendor sections
// in both the org-permissions view and the org-details feature permissions card.

export const SOFTWARE_TEAM_FLAGS: ReadonlySet<string> = new Set([
  'FB-AUTOLOCALIZATION', // Farmbuilder Autolocalization
  'FB-SOP-CUSTOM-NUMBERING-MODE', // Farmbuilder Custom Numbering Mode
  'FB-DELTA-T', // Farmbuilder Delta T
  'FB-TRANSFER-POINT-ANOMALIES', // FB Transfer Point Anomalies
  'FARMBUILDER-IMAGE-PAIR-LIST', // FarmBuilder Image Pair List
  'FGA-PERMISSIONS', // Farm & Inspection Sharing
  'USE-RM-INGESTION', // Use RM Ingestion
  'USE-UPLOADER-REDESIGN', // Uploader Redesign
  'FB-UX-GUARDRAILS', // FarmBuilder UX Guardrails
  'CONSTRUCTION-ZONE-BREAKDOWN', // Construction Zone Breakdown
]);

export const VENDOR_FLAGS: ReadonlySet<string> = new Set([
  'REPORT-BUILDER', // Report builder View
  'ORDER-DISPATCH', // Dispatch View
]);
